<template>
  <div>
    <el-row class="tree-content w100 mab_20" type="flex" :gutter="20">
      <el-col :span="24">
        <div class="filter-inline-panel cle">
          <el-form :inline="true" size="mini" :model="filterForm" class="filter-panel">
            <el-form-item label="名称" prop="keyword">
              <el-input v-model="filterForm.keyword" @keyup.enter="company_chaxun" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="片区/地块" prop="block_id">
              <el-cascader v-model="filterForm.block_id" class="w100" :options="area_data" :props="{value:'id',label:'name', multiple: true}" @change="area_f"></el-cascader>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" size="mini" @click="company_chaxun">搜索</el-button>
            </el-form-item>
          </el-form>
          <div class="list-opinion fr">
            <el-button type="primary" size="mini" @click="emailEdit()">新建</el-button>
          </div>
        </div>
        <el-table :data="list" border size="mini"  @selection-change="handleSelectionChange">
          <!-- <el-table-column type="selection" width="50" align="center"> </el-table-column> -->
          <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
          <el-table-column prop="zhongzhimingcheng" align="center" label="种质名称"></el-table-column>
          <el-table-column prop="area_name" align="center" label="片区/地块"></el-table-column>
          <el-table-column prop="zhongzhipu" align="center" label="种植圃"></el-table-column>
          <el-table-column prop="waiwenming" align="center" label="外文名"></el-table-column>
          <el-table-column prop="qinben" align="center" label="亲本"></el-table-column>
          <el-table-column prop="yuanchandi" align="center" label="原产地"></el-table-column>
          <el-table-column prop="Sjiyinxing" align="center" label="S基因型"></el-table-column>
          <el-table-column prop="laiyuan_value" align="center" label="来源">
            <template slot-scope="scope"> {{LAIYUAN[scope.row.laiyuan_value]}} </template>
          </el-table-column>
          <el-table-column prop="diaochashijian" align="center" label="调查时间"></el-table-column>
          <el-table-column prop="diaocharen" align="center" label="调查人"></el-table-column>
          <el-table-column prop="diaochadidian" align="center" label="调查地点"></el-table-column>
          <el-table-column prop="yongtu_value" align="center" label="用途">
            <template slot-scope="scope"> {{PURPOSE[scope.row.yongtu_value]}} </template>
          </el-table-column>
          <el-table-column prop="update_time" align="center" width="150" label="更新时间">
          	<template slot-scope="scope"> {{getTime(scope.row.update_time)}} </template>
          </el-table-column>
          <el-table-column label="操作" width="250" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="zidianleib(scope.row)">查看</el-button>
              <el-button size="mini" type="danger" @click="emailDelete(scope.row)">删除</el-button>
              <el-button size="mini" type="primary" @click="daochu">导出</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="24" class="page-pagination">
        <el-pagination style="float:right;" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
      </el-col>
      <data-data :editFormVisible="editFormVisible" :editForm_data="editForm" @editFormVisible_f="editFormVisible_f" :step_is="step_is" :step="step" :fenlei="fenlei"></data-data>
    </el-row>

    <el-dialog title="导出字段" width="900px" :visible="exportVisible" @close="exportVisible = false">
      <el-form :model="editForm" label-width="100px" ref="export_data">
        <el-checkbox :indeterminate="export_data.isIndeterminate" v-model="export_data.checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <el-checkbox-group v-model="export_data.export_header" @change="handleCheckedCitiesChange">
          <el-checkbox :label="index" v-for="(item,index) in export_list" class="checkbox_class" :key="index">{{item}}</el-checkbox>
        </el-checkbox-group>
      </el-form>
      <div class="tishiyu">
        <span class="" v-if="export_data.export_header.length==0">请选择要导出的字段</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="exportVisible = false">取消</el-button>
        <download-excel class="export-excel-wrapper" v-if="export_data.export_header.length>0" :data="export_list_data" :fields="json_fields" name="导出.xls">
          <el-button type="primary" @click.native="daochuguanb">导出</el-button>
        </download-excel>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import DataData from '../../components/datadata.vue';
var value_txet=["laiyuan_value", "yongtu_value", "shushi_value", "shuzi_value", "yinianshengzhitiaoyanse_value", "xinshaoyanse_value", "chunnenyese_value", "yebingyanse_value", "yepianyanse_value", "yepianpingzhanchengdu_value", "yexianxingzhuang_value", "yexianyanse_value", "hualeiyanse_value", "guoxing_value", "guoding_value", "zhengqidu_value", "fenghexian_value", "gengwa_value", "dise_value", "gaise_value", "zhuosechengdu_value", "zhidi_value", "guoxingjiwaiguanseze_value", "seze_value", "rouzhi_value", "zhiye_value", "xianwei_value", "kusewei_value", "xiangqi_value", "guohenianli_value", "fengwei_value", "xianshipinzhi_value", "zhucunxing_value", "jiandingyijian_value"];
var value_index=['LAIYUAN','PURPOSE','TREE_VIGOR','TREE_POSTURE','COLOUR_1','COLOUR_2','COLOUR_3','COLOUR_4','COLOUR_5','FLATTENING_DEGREE','FLATTENING_DEGREE','COLOUR_7','COLOUR_7','FRUIT_SHAPE','FRUIT_APEX','UNIFORMITY','SUTURE','STEM_DEPRESSION','BACKGROUND_COLOR','COLOUR_6','COLORING_DEGREE','TEXTURE','APPEARANCE_COLOR','COLOR_AND_LUSTRE','MEAT_QUALITY','JUICE','FIBRE','BITTERNESS','AROMA','STONE','FLAVOR','QUALITY','STORABILITY','OPINION'];
export default {
	components: {
		DataData
	},
	data() {
		return {
			that: this,
			exportVisible:false,
			fields:{},
			export_list_data:[],
			json_fields:{},
			export_data: {
				export_header: [],
				checkAll: false,
				isIndeterminate: false
			},
			export_list:{
				area_name:'片区',
				area_block_name:'地块',
				zhongzhimingcheng:'种质名称',
				zhongzhipu:'种植圃',
				waiwenming:'外文名',
				qinben:'亲本',
				yuanchandi:"原产地",
				Sjiyinxing:"S基因型",
				laiyuan_value:"来源",
				diaochashijian:"调查时间",
				diaocharen:"调查人",
				diaochadidian:"调查地点",
				yongtu_value:"用途",
				shushi_value:"树势",
				shushi_image:"树势图片",
				shuzi_value:"树姿",
				yinianshengzhitiaoyanse_value:"一年生枝条颜色",
				yinianshengzhitiaoyanse_image:"一年生枝条颜色(图片)",
				xinshaoyanse_value:"新梢颜色",
				xinshaoyanse_image:"新梢颜色(图片)",
				chunnenyese_value:"春嫩叶色",
				chunnenyese_image:"春嫩叶色(图片)",
				yebingyanse_value:"叶柄颜色",
				yebingyanse_image:"叶柄颜色(图片)",
				yepianyanse_value:"叶片",
				yepianyanse_image:"叶片(图片)",
				yepianpingzhanchengdu_value:"叶片平展程度",
				yexianxingzhuang_value:"叶腺性状",
				yexianxingzhuang_image:"叶腺性状(图片)",
				yexianyanse_value:"叶腺颜色",
				yexianshuliang:"叶腺数量(个)",
				mengyaqi_value:"萌芽期",
				shihuaqi_value:"始花期",
				mohuaqi_value:"末花期",
				hualeiyanse_value:"花蕾颜色",
				hualeiyanse_image:"花蕾颜色(图片)",
				
				huaduoshu:"花朵数量(朵)",
				huajing:"花径(mm)",
				huajing_image:"花径(图片)",
				guoshizhuoseqi_value:"果实着色期",
				guoshichengshuqi_value:"果实成熟期",
				guoshishengyuqian_value:"果实生育前",
				luoyeqi_value:"落叶期",
				pingjunguozhong:"平均果重(g)",
				zuidaguozhong:"最大果重(g)",
				guoxing_value:"果形",
				guoxing_image:"果形(图片)",
				guoding_value:"果顶",
				zhengqidu_value:"整齐度",
				fenghexian_value:"缝合线",
				gengwa_value:"梗洼",
				dise_value:"底色",
				gaise_value:"盖色",
				zhuosechengdu_value:"着色程度",
				zhidi_value:"质地",
				guoxingjiwaiguanseze_value:"果形及外观色泽",
				seze_value:"色泽",
				rouzhi_value:"肉质",
				guorouhoudu:"果肉厚度(mm)",
				zhiye_value:"汁液",
				xianwei_value:"纤维",
				kusewei_value:"苦涩味",
				xiangqi_value:"香气",
				guohenianli_value:"果核粘离",
				fengwei_value:"风味",
				kerongxingguxingwuhanliang:"可溶性固形物含量(%)",
				kerongxingtanghanliang:"可溶性糖含量(%)",
				kerongxingsuanhanliang:"可溶性酸含量(%)",
				Vchanliang:"Vc含量",
				kedidingsuanhanliang:"可滴定酸含量(%)",
				weiliangyuansu:"微量元素",
				keshilv:"可食率(%)",
				xianshipinzhi_value:"鲜食品质",
				zhucunxing_value:"耐贮性",
				lieguo:"裂果",
				youdian:"优点",
				quedian:"缺点",
				binghai:"病害",
				jiandingyijian_value:"鉴定意见",
				beizhu:"备注",
			},
			ids:[],
			step: 0,
			step_is: false,
			editFormVisible: false,
			editForm: {},
			list: [],
			filterForm: {
				keyword: '',
				block_id: [],
				block_ids: '',
			},
			pages: {
				page: 1,
				count: 100,
				perpage: 10,
			},
			area_data: [],
			area_block_data: [],
			LAIYUAN: [],
			PURPOSE: [],
			TREE_VIGOR: [],
			TREE_POSTURE: [],
			COLOUR_1: [],
			COLOUR_2: [],
			COLOUR_3: [],
			COLOUR_4: [],
			COLOUR_5: [],
			COLOUR_6: [],
			COLOUR_7: [],
			COLOUR_8: [],
			FLATTENING_DEGREE: [],
			LEAF_GLAND_CHARACTERS: [],
			FRUIT_SHAPE: [],
			FRUIT_APEX: [],
			UNIFORMITY: [],
			SUTURE: [],
			STEM_DEPRESSION: [],
			BACKGROUND_COLOR: [],
			COLORING_DEGREE: [],
			TEXTURE: [],
			APPEARANCE_COLOR: [],
			COLOR_AND_LUSTRE: [],
			MEAT_QUALITY: [],
			JUICE: [],
			FIBRE: [],
			BITTERNESS: [],
			AROMA: [],
			STONE: [],
			FLAVOR: [],
			QUALITY: [],
			STORABILITY: [],
			OPINION: [],
			ziduan:{},
			fenlei:'pinzhou',
		}
	},
	// 初始事件
	mounted: function (e) {
		this.config();
		this.init();
	},
	// 事件
	methods: {
		config() {
			var this_ = this;
			var url = "getDictionaryValue";
			var datas = {
				code: 'LAIYUAN,PURPOSE,TREE_VIGOR,TREE_POSTURE,COLOUR_1,FLATTENING_DEGREE,LEAF_GLAND_CHARACTERS,FRUIT_SHAPE,FRUIT_APEX,UNIFORMITY,SUTURE,STEM_DEPRESSION,BACKGROUND_COLOR,COLOUR_2,COLOUR_3,COLOUR_4,COLOUR_5,COLOUR_6,COLOUR_7,COLOUR_8,COLORING_DEGREE,TEXTURE,APPEARANCE_COLOR,COLOR_AND_LUSTRE,MEAT_QUALITY,JUICE,FIBRE,BITTERNESS,AROMA,STONE,FLAVOR,QUALITY,STORABILITY,OPINION',
			}
			this_.$post(url, datas).then((res) => {
				this_.ziduan=res;
				this_.LAIYUAN = res.LAIYUAN;
				this_.PURPOSE = res.PURPOSE;
				this_.TREE_VIGOR = res.TREE_VIGOR;
				this_.TREE_POSTURE = res.TREE_POSTURE;
				this_.COLOUR_1 = res.COLOUR_1;
				this_.COLOUR_2 = res.COLOUR_2;
				this_.COLOUR_3 = res.COLOUR_3;
				this_.COLOUR_4 = res.COLOUR_4;
				this_.COLOUR_5 = res.COLOUR_5;
				this_.COLOUR_6 = res.COLOUR_6;
				this_.COLOUR_7 = res.COLOUR_7;
				this_.COLOUR_8 = res.COLOUR_8;
				this_.FLATTENING_DEGREE = res.FLATTENING_DEGREE;
				this_.LEAF_GLAND_CHARACTERS = res.LEAF_GLAND_CHARACTERS;
				this_.FRUIT_SHAPE = res.FRUIT_SHAPE;
				this_.FRUIT_APEX = res.FRUIT_APEX;
				this_.UNIFORMITY = res.UNIFORMITY;
				this_.SUTURE = res.SUTURE;
				this_.STEM_DEPRESSION = res.STEM_DEPRESSION;
				this_.BACKGROUND_COLOR = res.BACKGROUND_COLOR;
				this_.COLORING_DEGREE = res.COLORING_DEGREE;
				this_.TEXTURE = res.TEXTURE;
				this_.APPEARANCE_COLOR = res.APPEARANCE_COLOR;
				this_.COLOR_AND_LUSTRE = res.COLOR_AND_LUSTRE;
				this_.MEAT_QUALITY = res.MEAT_QUALITY;
				this_.JUICE = res.JUICE;
				this_.FIBRE = res.FIBRE;
				this_.BITTERNESS = res.BITTERNESS;
				this_.AROMA = res.AROMA;
				this_.STONE = res.STONE;
				this_.FLAVOR = res.FLAVOR;
				this_.QUALITY = res.QUALITY;
				this_.STORABILITY = res.STORABILITY;
				this_.OPINION = res.OPINION;
			})
			var url = "areaOption";
			this_.$post(url, {}).then((res) => {
				this_.area_data = res;
			})
		},
		area_f(data) {
			var block_ids = [];
			var ii = 0;
			data.forEach(function (e, i) {
				block_ids[ii] = e[e.length - 1];
				ii++;
			});
			this.filterForm.block_ids = block_ids.length > 0 ? block_ids.join(',') : '';
		},
		// 初始化
		init() {
			var this_ = this;
			var url = "infoList";
			var datas = {
				fenlei: this_.fenlei,
				page: this_.pages.page,
				keyword: this_.filterForm.keyword,
				block_ids: this_.filterForm.block_ids,
				num: this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count = res.sum;
			})
		},
		// 搜索
		company_chaxun() {
			var this_ = this;
			var pages = this_.pages;
			pages['page'] = 1;
			this_.pages = pages;
			this_.init();
		},
		daochu(){
			// var this_ = this;
			// var ids=this_.ids;
			// var url = "explodeInfo";
			// var datas = {
			// 	keyword: this_.filterForm.keyword,
			// 	block_ids: this_.filterForm.block_ids,
			// 	ids:ids.join(','),
			// };
			// this_.$post(url, datas).then((res) => {
			// 	this_.export_list_data_f(res);
			// 	this_.exportVisible=true;
			// })
		},
		export_list_data_f(data){
			var this_=this;
			var value_txet_data=[];
			var y=0;
			data.forEach(function(e, i) {
				for (var j in e) {
					value_txet_data[y]=j;
					y++;
					var index=value_txet.indexOf(j);
					var value=e[j];
					// 判断字段是否在数据字典里
					if (index!=-1) {
						// 判断value不等于-1
						if (value!='-1') {
							e[j]=this_.ziduan[value_index[index]][value];
						}else{
							var name=j.split("_")[0];
							e[j]=e[name+'_text'];
						}
					}
				}
			});
			this_.export_list_data=data;
		},
		// 导出全选
		handleCheckAllChange(val) {
			var export_data = this.export_data;
			export_data['isIndeterminate'] = false;
			var cityOptions = [],
				y = 0,
				json_fields = {};
			var export_list = this.export_list;
			for (var i in export_list) {
				cityOptions[y] = i;
				y++;
				if (i.indexOf('image')!=-1) {
					json_fields[export_list[i]] = i+'.explode';
				}else{
					json_fields[export_list[i]] = i;
				}
			}
			export_data['export_header'] = val ? cityOptions : [];
			this.json_fields = val ? json_fields : {};
		},
		// 导出点击选择
		handleCheckedCitiesChange(value) {
			var cityOptions = [],
				y = 0,
				json_fields = {};
			var export_list = this.export_list;
			for (var i in export_list) {
				cityOptions[y] = i;
				y++;
				if (value.indexOf(i) != -1) {
					if (i.indexOf('image')!=-1) {
						json_fields[export_list[i]] = i+'.explode';
					}else{
						json_fields[export_list[i]] = i;
					}
				}
			}
			let checkedCount = value.length;
			var export_data = this.export_data;
			export_data['checkAll'] = checkedCount === cityOptions.length;
			export_data['isIndeterminate'] = checkedCount > 0 && checkedCount < cityOptions.length;
			this.json_fields = json_fields;
		},
		daochuguanb(){
			this.exportVisible=false;
		},
		// 表格选择
		handleSelectionChange(e) {
			var id = [];
			e.forEach(function (e, i) {
				id[i] = e.id
			});
			this.ids = id;
		},
		// 编辑
		emailEdit(e) {
			this.editForm = {
				fenlei:'pinzhou',
				area_arr: [],
				area: '',
				area_block: '',
				zhongzhimingcheng: '',
				zhongzhi_image: {
					show: [],
					save: [],
				},
				waiwenming: '',
				qinben: '',
				yuanchandi: '',
				qinben: '',
				Sjiyinxing: '',
				laiyuan_value: '',
				laiyuan_text: '',
				diaochashijian: '',
				diaocharen: '',
				diaochadidian: '',
				yongtu_value: '',

				shushi_value: '',
				shushi_image: {
					show: [],
					save: [],
				},
				shuzi_value: '',
				shuzi_image: {
					show: [],
					save: [],
				},


				yinianshengzhitiaoyanse_value: '',
				yinianshengzhitiaoyanse_text: '',
				yinianshengzhitiaoyanse_image: {
					show: [],
					save: [],
				},
				xinshaoyanse_value: '',
				xisnhaoyanse_text: '',
				xinshaoyanse_image: {
					show: [],
					save: [],
				},
				chunnenyese_value: '',
				chunnenyese_text: '',
				chunnenyese_image: {
					show: [],
					save: [],
				},
				yebingyanse_value: '',
				yebingyanse_image: {
					show: [],
					save: [],
				},
				yepianyanse_value: '',
				yepianyanse_text: '',
				yepianyanse_image: {
					show: [],
					save: [],
				},
				yepianpingzhanchengdu_value: '',
				yexianxingzhuang_value: '',
				yexianxingzhuang_image: {
					show: [],
					save: [],
				},
				yexianyanse_value: '',
				yexianshuliang: '',
				mengyaqi_value: '',
				shihuaqi_value: '',
				mohuaqi_value: '',
				hualeiyanse_value: '',
				huaduoshu: '',
				huajing: '',
				huajing_image: {
					show: [],
					save: [],
				},
				guoshizhuoseqi_value: '',
				guoshichengshuqi_value: '',
				guoshishengyuqian_value: '',
				luoyeqi_value: '',

				pingjunguozhong: '',
				zuidaguozhong: '',
				guoxing_value: '',
				guoxing_text: '',
				guoxing_image: {
					show: [],
					save: [],
				},
				guoding_value: '',
				zhengqidu_value: '',
				fenghexian_value: '',
				gengwa_value: '',

				dise_value: '',
				gaise_value: '',
				zhuosechengdu_value: '',
				zhidi_value: '',
				guoxingjiwaiguanseze_value: '',

				seze_value: '',
				rouzhi_value: '',
				guorouhoudu: '',
				zhiye_value: '',
				xianwei_value: '',
				kusewei_value: '',
				xiangqi_value: '',
				guohenianli_value: '',

				fengwei_value: '',
				kerongxingguxingwuhanliang: '',
				kerongxingtanghanliang: '',
				kerongxingsuanhanliang: '',
				Vchanliang: '',
				kedidingsuanhanliang: '',
				weiliangyuansu: '',
				keshilv: '',
				xianshipinzhi_value: '',
				zhucunxing_value: '',
				lieguo: '',
				youdian: '',
				quedian: '',
				binghai: '',
				jiandingyijian_value: '',
				beizhu: '',
				info_id: '',
			};
			this.step=0;
			this.editFormVisible = true;
		},
		editFormVisible_f() {
			this.editFormVisible = false;
			this.init();
		},
		// 删除
		emailDelete(e) {
			var this_ = this;
			var url = "infoDelete";
			var datas = {
				id: e.id
			};
			this_.$confirm('确认删除吗?', '提示', {
				//type: 'warning'
			}).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success('删除成功');
					this_.init();
				})
			}).catch(() => {});
		},
		zidianleib(e) {
			this.$router.push({
				path: 'list_info',
				query: {
					id: e.id
				}
			});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {
		gettime(v,that){
			if (v) {
				return that.getTime(v,'y');
			}else{
				return v;
			}
		},
	}
}
</script>
<style scoped>
.filter-panel {
	display: inline-block;
	width: 80%;
	vertical-align: top;
}
.page-pagination {
	padding: 20px 10px;
}
.checkbox_class {
	margin-top: 10px;
}
.export-excel-wrapper {
	display: inline-block;
}
.tishiyu {
	height: 30px;
	text-align: center;
	font-size: 20px;
	color: #ff0000;
	display: block;
	margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/list/index_pinzhou.vue